import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ChappiChatbot } from '../common/chappi/chappi-chatbot';
import { customDashboardRoute } from '../common/routes';
import { DEFAULT_LANDING_PAGE } from '../common/v2/constants';
import {
  useFeatureFlagsServiceContext,
  useLatestPreferencesContext,
} from '../common/v2/context/contexts';
import { DashboardContextProvider } from '../common/v2/context/DashboardContextProvider';
import { PrivateRoute } from './PrivateRoute';

export const CustomDashboardRoutes = () => {
  console.log2('DashboardRoutes');
  const featureFlagsService = useFeatureFlagsServiceContext();
  const latestPreferences = useLatestPreferencesContext();
  const companyLandingPage =
    latestPreferences.customLandingPage ?? DEFAULT_LANDING_PAGE;
  const allowCustomDashboards = featureFlagsService.isCustomDashboardsEnabled();

  return (
    <DashboardContextProvider>
      <Switch>
        {allowCustomDashboards && (
          <PrivateRoute
            key={customDashboardRoute.id}
            component={customDashboardRoute.comp()}
            {...customDashboardRoute}
          />
        )}
        <Redirect from="*" to={companyLandingPage} />
      </Switch>
      {featureFlagsService.isChappiEnabled() && <ChappiChatbot />}
    </DashboardContextProvider>
  );
};
